import { render, staticRenderFns } from "./results.vue?vue&type=template&id=d2ae1b4c&"
import script from "./results.vue?vue&type=script&lang=js&"
export * from "./results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2ae1b4c')) {
      api.createRecord('d2ae1b4c', component.options)
    } else {
      api.reload('d2ae1b4c', component.options)
    }
    module.hot.accept("./results.vue?vue&type=template&id=d2ae1b4c&", function () {
      api.rerender('d2ae1b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/dataImport/components/results.vue"
export default component.exports